import * as React from 'react';

function extractor(element: React.ReactElement) {
  return React.Children.map(element, (child) => {
    if (typeof child === 'string') {
      return child;
    }
    if (child && child.props && child.props.children) {
      return extractor(child.props.children);
    }
    return '';
  });
}

export const extractText = (element: React.ReactNode): string => {
  if (!element) {
    return '';
  }

  if (typeof element === 'string') return element;

  if (typeof element === 'object') {
    return extractor(element as React.ReactElement).join('');
  }
};

export default extractText;
